// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3K8VF","header":"ReportDetails_header__200gI","title":"ReportDetails_title__2Umv9","left":"ReportDetails_left__NaWcL"};